import React from 'react'
import { Router, Route, Switch, Redirect } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import MainPage from './containers/MainPage'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropertiesPage from './containers/PropertiesPage'
import AdCouncilFranchiseePage from './containers/AdCouncilFranchiseePage'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import { isBaseDomain, getToken } from './utils'
import './App.css'

import { userInfo } from './actions'

import NonAuthenticatedContainer from './features/authentication/containers/NonAuthenticatedContainer'

import { ThemeProvider } from '@smooth-ui/core-em'
import smoothUitheme from 'UILibrary/theme'
import ReactGA from 'react-ga'
import PricingPage from './containers/PricingPage'
import WelcomePage from './containers/WelcomePage'
import AboutUs from './containers/AboutUs'
import ContactUs from './containers/ContactUs'
import Terms from './containers/Terms'
import { GoogleLoginFrame } from './features/authentication/components'

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID)

const history = createBrowserHistory()
const theme = createMuiTheme({
  typography: {
    // Use the system font.
    fontFamily: '"Rubik","Helvetica Neue",Arial,sans-serif',
  },
})

class MainComponent extends React.Component {
  componentDidMount() {
    if (this.props.user.isLoading && getToken()) {
      this.props.userInfo(getToken())
    }
  }

  render() {
    return this.props.children
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ userInfo }, dispatch)
}

const Main = connect(
  mapStateToProps,
  mapDispatchToProps
)(MainComponent)

const App = props => (
  <MuiThemeProvider theme={theme}>
    <ThemeProvider theme={smoothUitheme}>
      <Router history={history}>
        <Route
          render={() => (
            <Main>
              <Switch>
                <Route exact path="/" render={() => (isBaseDomain(window.location.hostname) ? <MainPage /> : <AdCouncilFranchiseePage />)} />
                <Route exact path="/listings/:propertyID" component={MainPage} />
                <Route exact path="/properties" component={PropertiesPage} />
                <Route exact path="/properties/:propertyID" component={PropertiesPage} />
                <Route exact path="/details/:propertyID" render={() => <AdCouncilFranchiseePage />} />
                <Route exact path="/settings" component={MainPage} />
                <Route exact path="/pricing" component={PricingPage} />
                <Route exact path="/welcome" component={WelcomePage} />
                <Route exact path="/googleLogin" component={GoogleLoginFrame} />
                <Route path="/auth" component={NonAuthenticatedContainer} />
                <Route exact path="/aboutUs" component={AboutUs} />
                <Route exact path="/contactUs" component={ContactUs} />
                <Route exact path="/terms" component={Terms} />
                <Redirect to="/" />
              </Switch>
            </Main>
          )}
        />
      </Router>
    </ThemeProvider>
  </MuiThemeProvider>
)

export default App



// WEBPACK FOOTER //
// ./src/App.js